import { useAdvAccountFixAlertDialog } from '~/components/common/AdvAccountFixAlertDialog'
import { useAnsweredLiteracySurveyQuery } from '~/generated/graphql'
import { useAdGuidelineDialog } from '../campaigns/AdGuidelineDialog'
import { useTermsDialog } from '../campaigns/TermsDialog'
import { proxyLogin } from '~/lib/proxyLogin'

// ダイアログがいくつも表示されないよう出し分けるためのコンポーネント
export const InductionDialogs = () => {
  const {
    loading: adGuidelineLoading,
    needAgree: needAgreeAdGuideline,
    dialog: adGuidelineDialog,
  } = useAdGuidelineDialog()
  const { shouldReAgree: shouldReAgreeToTerms, dialog: termsDialog } = useTermsDialog()
  const { shouldFixAdvAccount, dialog: advAccountFixAlertDialog } = useAdvAccountFixAlertDialog()

  const { data: literacySurvey, loading: literacySurveyLoading } = useAnsweredLiteracySurveyQuery()

  if (proxyLogin.isProxyLogin()) return null // 代理ログイン時は表示しない

  if (shouldReAgreeToTerms === 'loading' || adGuidelineLoading || literacySurveyLoading) {
    return null
  }

  // リテラシーアンケートがある場合は、その他のダイアログは表示しない
  if (!literacySurvey?.viewerAsAdvertiser.answeredLiteracySurvey) return null

  if (needAgreeAdGuideline) return adGuidelineDialog
  if (shouldReAgreeToTerms) return termsDialog
  if (shouldFixAdvAccount) return advAccountFixAlertDialog

  return null
}
